import { JobPhaseUpdatableInterface } from '../interfaces/job-phase-updatable.interface';
import { PartialType, PickType } from '@nestjs/swagger';
import { JobPhaseDto } from './job-phase.dto';

export class JobPhaseUpdateDto
  extends PartialType(
    PickType(JobPhaseDto, [
      'required',
      'requested',
      'trimOptionSelected',
      'notes',
      'approved',
      'approvedGeo',
      'approvedGeoAccuracy',
      'approvingUserId',
      'contractorId',
      'suggestedContractorId',
      'dateAssigned',
      'requestDelayDays',
      'readyHour',
      'dateStart',
      'readinessStatus',
      'costTotal',
    ]),
  )
  implements JobPhaseUpdatableInterface {}
